const zapiekankiArr = [
  ['Tradycyjna', ['ser', 'pieczarki'], ['9', '00'], 1],
  ['Vege', ['ser', 'pieczarki', 'surówki'], ['9', '50'], 2],
  ['z Szynką', ['ser', 'pieczarki', 'szynka'], ['10', '00'], 3],
  [
    'z Szynką i Ogórkiem',
    ['ser', 'pieczarki', 'szynka', 'świeży ogórek'],
    ['10', '50'],
    4,
  ],
  ['Kebab', ['ser', 'pieczarki', 'mięso kebab'], ['11', '00'], 5],
]

export default zapiekankiArr
